
import { useGetAllInstallationTypesQuery } from 'generated/graphql';

import React from 'react';

export interface IData {
  id: string;
  name: string;
  displayName: string;
}

export function useQuery() {
  const tuple = useGetAllInstallationTypesQuery({
    variables: {
    }
  });

  return React.useMemo(
    () => {

      const data: IData[] = tuple.data?.installationTypes?.map((node) => ({
        id: node.id,
        name: node.name,
        displayName: node.displayName
      }))
     ?? [];

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
